import {ReactElement} from "react";
import {styles} from "./styles/VerticalSearchbarDivider.style";

const VerticalSearchbarDivider = (): ReactElement => (
  <div style={styles.VerticalSearchbarDivider}></div>
);

export default VerticalSearchbarDivider;